module.exports = __webpack_public_path__ + "static/media/ArshanDabirsiaghi.1649875e.png";